import React from 'react';
import { DispatchJobTabNumbers } from './Dispatch';

export default class DispatchRightContentFooter extends React.Component {
    planningTabIsActive = () => {
        const { activeJobTab } = this.props;

        return activeJobTab.number === DispatchJobTabNumbers.Planning;
    };

    cancellationsTabIsActive = () => {
        const { activeJobTab } = this.props;

        return activeJobTab.number === DispatchJobTabNumbers.Cancellations;
    };

    anyPlanningJobs = () => {
        const { planningJobs } = this.props;

        return planningJobs && planningJobs.length;
    };

    anyCancellationJobs = () => {
        const { cancellationJobs } = this.props;

        return cancellationJobs && cancellationJobs.length;
    };

    getPlanningText = () => {
        const {
            planningJobs,
            planningJobsMaxRows,
            planningJobsFilteredCount,
            hideCancelledOrders,
            hiddenCancelledOrdersCount,
        } = this.props;

        const hiddenCancelledText =
            hideCancelledOrders && hiddenCancelledOrdersCount > 0
                ? ` ${hiddenCancelledOrdersCount} cancelled orders hidden.`
                : '';

        return this.anyPlanningJobs()
            ? `Displaying ${planningJobs.length} of ${planningJobsMaxRows} orders (${planningJobsMaxRows - planningJobsFilteredCount} filtered).${hiddenCancelledText}`
            : `No orders with resource openings found for the selected filters.${hiddenCancelledText}`;
    };

    getCancellationText = () => {
        const {
            planningJobsMaxRows,
            cancellationJobs,
            cancellationJobsFilteredCount,
            cancellationJobsMaxRows,
        } = this.props;

        return this.anyCancellationJobs()
            ? `Displaying ${
                  cancellationJobs.length
              } of ${cancellationJobsMaxRows} cancellations (${
                  planningJobsMaxRows - cancellationJobsFilteredCount
              } filtered).`
            : 'No cancellations found.';
    };

    getFooterText = () => {
        const { loading, resourcesLoading, jobsLoading } = this.props;

        if (loading || resourcesLoading || jobsLoading) {
            return 'Loading...';
        }

        if (this.planningTabIsActive()) {
            return this.getPlanningText();
        }

        return this.getCancellationText();
    };

    render() {
        return (
            <div id="dispatchRightContentFooter">
                <small>{this.getFooterText()}</small>
            </div>
        );
    }
}
